import { Fragment, useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { dateCheck } from '@utils/cookies';
import * as S from './styles';
import { mglGray } from '@/styles/designSystemColors';

const blackFridayColors = {
  yellow: '#FFF000',
  black: '#050515',
  white: mglGray.mglGray50,
  neonBlue: '#00D9FF',
  darkBlack: '#000000',
  electricBlue: '#0080FF',
  brightBlue: '#00E5FF',
  lightBlue: '#4DD0E1',
  deepBlack: '#0A0A0A',
};

const bannerData = [
  {
    name: 'pre-bf2025',
    startDate: '11/17/2025 19:15',
    endDate: '11/26/2025 23:59',
    link: {
      url: 'https://calendar.google.com/calendar/event?action=TEMPLATE&tmeid=NTBxNGYwbHNxa2I5MjVkaHJtOWJvbjNvYm4gcGFtZWxhQGNhbmFsdGVjaC5jb20uYnI&tmsrc=pamela%40canaltech.com.br',
    },
    color: {
      barColors: 'linear-gradient(90deg, #00D9FF, #00E5FF, #00D9FF)',
      textColor: blackFridayColors.deepBlack,
      buttonBackground: blackFridayColors.darkBlack,
      textButtonColor: blackFridayColors.brightBlue,
      textBackground: blackFridayColors.deepBlack,
    },
    texts: {
      md: 'NÃO PERCA A BLACK FRIDAY 2025 DO CANALTECH!',
      sm: 'NÃO PERCA: OS GUARDIÕES DA BLACK FRIDAY 2025',
      xs: 'BLACK FRIDAY CANALTECH!',
      buttonText: 'ADICIONAR NA AGENDA',
    },
    closedByUser: false,
  },
  {
    name: 'dia-bf2025',
    startDate: '11/27/2025 00:00',
    endDate: '11/27/2025 18:59',
    link: {
      url: 'https://calendar.google.com/calendar/event?action=TEMPLATE&tmeid=NTBxNGYwbHNxa2I5MjVkaHJtOWJvbjNvYm4gcGFtZWxhQGNhbmFsdGVjaC5jb20uYnI&tmsrc=pamela%40canaltech.com.br',
    },
    color: {
      barColors: 'linear-gradient(90deg, #00D9FF, #00E5FF, #00D9FF)',
      textColor: blackFridayColors.deepBlack,
      buttonBackground: blackFridayColors.darkBlack,
      textButtonColor: blackFridayColors.brightBlue,
      textBackground: blackFridayColors.deepBlack,
    },
    texts: {
      md: 'É HOJE, NÃO PERCA A NOSSA LIVE DA BLACK FRIDAY!',
      sm: 'HOJE: OS GUARDIÕES DA BLACK FRIDAY 2025',
      xs: 'HOJE: BLACK FRIDAY CANALTECH!',
      buttonText: 'ADICIONAR NA AGENDA',
    },
    closedByUser: false,
  },
  {
    name: 'dia-bf2025-entre-lives',
    startDate: '11/28/2025 03:00',
    endDate: '11/28/2025 10:59',
    link: {
      url: 'https://calendar.google.com/calendar/event?action=TEMPLATE&tmeid=NWZqMjFmdTc4M3QxZmoyOHZtaTdmNmo5NDcgcGFtZWxhQGNhbmFsdGVjaC5jb20uYnI&tmsrc=pamela%40canaltech.com.br',
    },
    color: {
      barColors: 'linear-gradient(90deg, #00D9FF, #00E5FF, #00D9FF)',
      textColor: blackFridayColors.deepBlack,
      buttonBackground: blackFridayColors.darkBlack,
      textButtonColor: blackFridayColors.brightBlue,
      textBackground: blackFridayColors.deepBlack,
    },
    texts: {
      md: 'É HOJE, NÃO PERCA A NOSSA LIVE DA BLACK FRIDAY!',
      sm: 'HOJE: OS GUARDIÕES DA BLACK FRIDAY 2025',
      xs: 'HOJE: BLACK FRIDAY CANALTECH!',
      buttonText: 'ADICIONAR NA AGENDA',
    },
    closedByUser: false,
  },
  {
    name: 'live-bf2025-primeira',
    startDate: '11/27/2025 19:00',
    endDate: '11/28/2025 02:00',
    link: {
      url: 'https://canaltech.com.br/live/',
    },
    color: {
      barColors: 'linear-gradient(90deg, #00FFE5, #00D9FF, #4DD0E1, #00D9FF, #00FFE5)',
      textColor: blackFridayColors.deepBlack,
      buttonBackground: blackFridayColors.darkBlack,
      textButtonColor: blackFridayColors.brightBlue,
      textBackground: blackFridayColors.deepBlack,
    },
    texts: {
      md: 'ESTAMOS AO VIVO: BLACK FRIDAY CANALTECH 2025!',
      sm: 'AO VIVO: BLACK FRIDAY CANALTECH 2025!',
      xs: 'AO VIVO: BLACK FRIDAY CANALTECH!',
      buttonText: 'ASSISTIR A LIVE',
    },
    closedByUser: false,
  },
  {
    name: 'live-bf2025-segunda',
    startDate: '11/28/2025 11:00',
    endDate: '11/28/2025 14:00',
    link: {
      url: 'https://canaltech.com.br/live/',
    },
    color: {
      barColors: 'linear-gradient(90deg, #00FFE5, #00D9FF, #4DD0E1, #00D9FF, #00FFE5)',
      textColor: blackFridayColors.deepBlack,
      buttonBackground: blackFridayColors.darkBlack,
      textButtonColor: blackFridayColors.brightBlue,
      textBackground: blackFridayColors.deepBlack,
    },
    texts: {
      md: 'ESTAMOS AO VIVO: BLACK FRIDAY CANALTECH 2025!',
      sm: 'AO VIVO: BLACK FRIDAY CANALTECH 2025!',
      xs: 'AO VIVO: BLACK FRIDAY CANALTECH!',
      buttonText: 'ASSISTIR A LIVE',
    },
    closedByUser: false,
  },
  {
    name: 'pos-bf2025',
    startDate: '11/28/2025 15:00',
    endDate: '11/30/2025 23:59',
    link: {
      url: 'https://ofertas.canaltech.com.br/top/?utm_source=canaltech&utm_medium=site-barra&utm_campaign=bf2025',
    },
    color: {
      barColors: 'linear-gradient(90deg, #4DD0E1, #00D9FF, #4DD0E1)',
      textColor: blackFridayColors.deepBlack,
      buttonBackground: blackFridayColors.darkBlack,
      textButtonColor: blackFridayColors.brightBlue,
      textBackground: blackFridayColors.deepBlack,
    },
    texts: {
      md: 'CONFIRA AS MELHORES OFERTAS DESTA BLACK FRIDAY',
      sm: 'AS MELHORES OFERTAS DESTA BLACK FRIDAY',
      xs: 'AS MELHORES OFERTAS DESTA BLACK',
      buttonText: 'VER OFERTAS',
    },
    closedByUser: false,
  },
  {
    name: 'premio-ct-2023',
    startDate: '12/11/2023 12:45',
    endDate: '01/31/2024 23:59',
    link: {
      url: 'https://premio.canaltech.com.br/2023/?utm_source=canaltech&utm_medium=site-barra&utm_campaign=premio-canaltech',
    },
    color: {
      barColors: 'linear-gradient(224deg, #a92fd8, #20bcfe)',
      textColor: mglGray.mglGray50,
      buttonBackground: mglGray.mglGray900,
      textButtonColor: mglGray.mglGray50,
      textBackground: mglGray.mglGray50,
    },
    emphasis: {
      md: 'PRÊMIO CANALTECH: ',
      sm: 'PRÊMIO CANALTECH: Participe e Vote!',
      xs: 'Vote no Prêmio Canaltech!',
    },
    texts: {
      md: 'escolha os melhores da tecnologia de 2023!',
      sm: '',
      xs: '',
      buttonText: 'VOTAR AGORA!',
    },
  },
  {
    name: 'premio-ct-2023-resultado-sorteio',
    startDate: '02/19/2024 12:30',
    endDate: '03/01/2024 23:59',
    link: {
      url: 'https://premio.canaltech.com.br/2023/?utm_source=canaltech&utm_medium=site-barra&utm_campaign=sorteio-premio-canaltech',
    },
    color: {
      barColors: 'linear-gradient(224deg, #20bcfe, #a92fd8)',
      textColor: mglGray.mglGray50,
      buttonBackground: mglGray.mglGray900,
      textButtonColor: mglGray.mglGray50,
      textBackground: mglGray.mglGray50,
    },
    emphasis: {
      md: '',
      sm: 'PRÊMIO CT! Resultado do Sorteio',
      xs: 'Ver sorteados do Prêmio',
    },
    texts: {
      md: 'SAIU O RESULTADO DO SORTEIO DO PRÊMIO CANALTECH!',
      sm: '',
      xs: '',
      buttonText: 'CONFERIR',
    },
  },
];

export default function Banner() {
  const router = useRouter();
  const [testBanner, setTestBanner] = useState<string | null>(null);
  const [showAllBanners, setShowAllBanners] = useState(false);

  const excludedRoutes = ['/live', '/oppo'];
  const currentPath = router?.pathname || '';
  const shouldHideBanner = excludedRoutes.includes(currentPath);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const params = new URLSearchParams(window.location.search);
      const bannerTest = params.get('banner-test');
      const showAll = params.get('banner-show-all');

      setTestBanner(bannerTest);
      setShowAllBanners(showAll === 'true');
    }
  }, []);

  if (shouldHideBanner) {
    return null;
  }

  return (
    <>
      {bannerData.map(banner => {
        const isTestMode = testBanner === banner.name || showAllBanners;
        const bannerIsInactive = !dateCheck(banner.startDate, banner.endDate, new Date());
        const shouldShowBanner = isTestMode || !bannerIsInactive;

        return (
          <Fragment key={banner.name}>
            {shouldShowBanner && (
              <section
                style={{ background: banner.color.barColors }}
                className="fixed left-0 top-0 z-[988] mt-[60px] h-[50px] min-h-[50px] w-full overflow-hidden p-0 pl-0 text-mglGray50 md:mt-0 tablet:pl-[60px] [&+div+div]:mt-[50px] [&+div]:mt-[50px] [&_svg]:ml-[10px] [&_svg]:cursor-pointer">
                <div className="mx-auto my-0 flex h-full w-full max-w-full basis-full items-center justify-center px-[0.625rem] tablet:max-w-[83.3333%] tablet:basis-[83.3333%] desktop:px-0">
                  {isTestMode && (
                    <div className="bg-red-500 absolute left-2 top-1 rounded px-2 py-1 text-[10px] font-bold text-white">TESTE: {banner.name}</div>
                  )}
                  <div className="hidden items-center px-0 py-2 desktop:flex">
                    <strong style={{ color: banner.color.textBackground }} className="hidden items-center whitespace-pre-wrap font-medium desktop:flex">
                      {banner.emphasis?.md && <strong className="p-2">{banner.emphasis.md}</strong>} {banner.texts.md}
                    </strong>
                    <S.VoteButton href={banner.link.url} target="_blank" title={banner.texts.md}>
                      <strong style={{ color: banner.color.textButtonColor }}>{banner.texts.buttonText}</strong>
                    </S.VoteButton>
                  </div>
                  <div className="hidden w-full items-center py-2 tablet:flex desktop:hidden">
                    <S.VoteButton href={banner.link.url} target="_blank" title={banner.texts.sm}>
                      <strong style={{ color: banner.color.textButtonColor }}>{banner.emphasis?.sm || banner.texts.sm}</strong>
                    </S.VoteButton>
                  </div>
                  <div className="flex w-full items-center px-0 py-2 tablet:hidden">
                    <S.VoteButton href={banner.link?.url} target="_blank" title={banner.texts?.xs}>
                      <strong style={{ color: banner.color.textButtonColor }}>{banner.emphasis?.xs || banner.texts?.xs}</strong>
                    </S.VoteButton>
                  </div>
                </div>
              </section>
            )}
          </Fragment>
        );
      })}
    </>
  );
}
